import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import './BlogPost.css';
import ContactCTA from '../../components/ContactCTA/ContactCTA';

const BlogPost = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPost = () => {
      const dummyPosts = {
        'comfyui-tutorial': {
          title: "如何使用ComfyUI进行AI创作",
          author: { name: "Yoji", avatar: "/images/yoji-profile.png" },
          date: "2024-01-15",
          readTime: "12min read",
          category: "AI工具",
          content: `
            <h2>ComfyUI简介</h2>
            <p>ComfyUI是一个强大的AI创作工具，它提供了直观的节点式界面，让创作者能够更灵活地控制AI生成过程。本文将带你深入了解如何使用ComfyUI进行高效的AI创作。</p>

            <h2>基础设置</h2>
            <p>首先，我们需要正确配置ComfyUI环境，包括安装必要的模型和依赖。确保你的系统满足以下要求：
              - Python 3.10+
              - CUDA支持的显卡
              - 足够的显存(建议8GB以上)
            </p>

            <h2>工作流程设计</h2>
            <p>了解如何构建高效的工作流程，从简单的图像生成到复杂的多步骤处理。我们将探讨：
              - 基础节点的使用方法
              - 常用工作流程模板
              - 参数优化技巧
              - 批处理操作方法
            </p>

            <h2>进阶技巧</h2>
            <p>探索高级功能，如ControlNet、LoRA训练等，提升创作效果。我们还将讨论：
              - 自定义节点开发
              - 工作流程优化
              - 性能调优方法
              - 常见问题解决
            </p>
          `
        },
        'competitor-analysis': {
          title: "为什么我们在构建产品前先寻找你的对手",
          author: { name: "Yoji", avatar: "/images/yoji-profile.png" },
          date: "2024-01-20",
          readTime: "8min read",
          image: "/images/competitor-analysis.jpg",
          content: `
            <h2>竞品分析的重要性</h2>
            <p>在开始产品开发之前，深入了解市场竞争对手可以帮助我们避免重复造轮子，找到市场空白点。本文将分享如何进行有效的竞品分析。</p>

            <h2>竞品分析方法</h2>
            <p>系统的竞品分析应该包括以下几个方面：
              - 产品功能对比
              - 用户体验分析
              - 商业模式研究
              - 市场定位评估
            </p>

            <h2>数据收集与分析</h2>
            <p>如何收集和分析竞品数据：
              - 用户评价分析
              - 功能特性对比
              - 市场份额研究
              - 发展趋势预测
            </p>
          `
        },
        'no-code-development': {
          title: "不懂代码，如何构建网站和产品",
          author: { name: "Yoji", avatar: "/images/yoji-profile.png" },
          date: "2024-01-25",
          readTime: "10min read",
          image: "/images/no-code.jpg",
          content: `
            <h2>No-Code工具介绍</h2>
            <p>现代No-Code工具让不懂编程的创作者也能构建专业的网站和产品。我们将探索最流行的No-Code平台及其特点。</p>

            <h2>工具选择指南</h2>
            <p>如何选择适合你需求的No-Code工具：
              - 网站建设工具
              - 应用开发平台
              - 自动化工具
              - 数据管理解决方案
            </p>

            <h2>实战技巧</h2>
            <p>从构思到上线的完整指南：
              - 需求分析
              - 原型设计
              - 功能实现
              - 测试与优化
            </p>
          `
        },
        'figma-workflow': {
          title: "Figma如何改变我们的设计方式",
          author: { name: "Yoji", avatar: "/images/yoji-profile.png" },
          date: "2024-02-01",
          readTime: "7min read",
          image: "/images/figma-workflow.jpg",
          content: `
            <h2>Figma的革新</h2>
            <p>Figma作为现代设计工具，如何改变了设计师的工作方式和团队协作模式。</p>

            <h2>核心功能详解</h2>
            <p>探索Figma的核心优势：
              - 实时协作
              - 组件系统
              - 自动布局
              - 原型交互
            </p>

            <h2>效率提升技巧</h2>
            <p>提高设计效率的实用技巧：
              - 快捷键使用
              - 插件推荐
              - 工作流程优化
              - 团队协作最佳实践
            </p>
          `
        },
        'market-analysis': {
          title: "为什么要时刻关注市场",
          author: { name: "Yoji", avatar: "/images/yoji-profile.png" },
          date: "2024-02-05",
          readTime: "6min read",
          image: "/images/market-analysis.jpg",
          content: `
            <h2>市场洞察的重要性</h2>
            <p>在快速变化的市场环境中，及时的市场洞察可以帮助我们抓住机遇，规避风险。</p>

            <h2>市场监测方法</h2>
            <p>建立有效的市场监测系统：
              - 数据收集渠道
              - 分析工具使用
              - 趋势识别方法
              - 竞争对手跟踪
            </p>

            <h2>决策支持</h2>
            <p>如何利用市场数据支持决策：
              - 数据分析框架
              - 趋势预测方法
              - 风险评估模型
              - 战略调整建议
            </p>
          `
        },
        'user-needs': {
          title: "需求才是产品的源头",
          author: { name: "Yoji", avatar: "/images/yoji-profile.png" },
          date: "2024-02-10",
          readTime: "9min read",
          image: "/images/user-needs.jpg",
          content: `
            <h2>需求分析基础</h2>
            <p>深入探讨用户需求分析的重要性，以及如何准确捕捉用户痛点。</p>

            <h2>需求收集方法</h2>
            <p>有效的需求收集技巧：
              - 用户访谈
              - 问卷调查
              - 行为分析
              - 竞品研究
            </p>

            <h2>需求转化</h2>
            <p>如何将用户需求转化为产品功能：
              - 需求优先级排序
              - 功能规划方法
              - 原型验证
              - 迭代优化流程
            </p>
          `
        }
      };

      setTimeout(() => {
        setPost(dummyPosts[id]);
        setLoading(false);
      }, 500);
    };
    
    fetchPost();
  }, [id]);

  // 返回上一页
  const goBack = () => {
    navigate(-1);
  };

  if (loading) {
    return <div className="loading">加载中...</div>;
  }

  if (!post) {
    return <div>文章未找到</div>;
  }

  return (
    <div className="blog-post">
      <div className="post-header">
        <div className="post-meta">
          <span className="post-date">{post.date}</span>
          <span className="post-category">{post.category}</span>
          <span className="post-read-time">{post.readTime}</span>
        </div>
        <h1>{post.title}</h1>
        <div className="post-author">
          <img src={post.author.avatar} alt={post.author.name} />
          <span>{post.author.name}</span>
        </div>
      </div>

      <div className="post-content" dangerouslySetInnerHTML={{ __html: post.content }} />
      
      <div className="post-footer">
        <Link to="/blog" className="back-to-blog">
          <span>←</span> 返回博客列表
        </Link>
      </div>

      <ContactCTA />
    </div>
  );
};

export default BlogPost; 